import React, {useState, useEffect, useRef} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {useNavigate} from "react-router-dom";
import '../../App.css';
import Select from 'react-select';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash, faEye} from "@fortawesome/free-solid-svg-icons";
import {library} from "@fortawesome/fontawesome-svg-core";
import {Alert, Button, Modal, Form, Row, Col, Table, FormControl} from "react-bootstrap";
import {usePurchases} from "../../PurchaseContext";
import {useSuppliers} from "../../SupplierContext";
import {useAccounts} from "../../contextjs/AccountContext";
import {useTransactions} from "../../contextjs/TransactionContext";
import {useProducts} from "../../ProductContext";
import ReturnPurchase from "./purchasereturn";
import { FaUndoAlt } from "react-icons/fa";
import Pagination from "react-bootstrap/Pagination";
import { fetchCurrentStore } from "../../api/api";
// import {errorMessage} from "jest-validate/build/errors";
// import { apiInstance } from "../../api/api";
// import { FaCheckSquare, FaHourglassHalf, FaTimesCircle } from "react-icons/fa";

library.add(faTrash); //add trash icon to the library

function Purchase(){
    const [currentStore, setCurrentStore] = useState(null);
   const {productsForPurchase, fetchAllProductsForPurchase} = useProducts();
    const {suppliers, fetchAllSuppliers} = useSuppliers();
    const {purchases, fetchAllPurchases, createPurchase, updatePurchase, totalPurchases, fetchPurchasesPaginated} = usePurchases();

    // pagination
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 20;

    const [showPurchaseModal, setShowPurchaseModal] = useState(false);
    const initialNewPurchaseState = {
        supplier: '',
        purchase_date: '',
        invoice_number: '',
        total_amount: 0,
        products: [{productId: '', unitId: '', conversion_factor: 1.0,  quantity: 0, purchase_price: '', last_purchase_price_base: null}],
        has_return: false,
    };
    const [newPurchase, setNewPurchase] = useState(initialNewPurchaseState);
    const [totalAmount, setTotalAmount] = useState(0);
    const [selectedPurchase, setSelectedPurchase] = useState(null); //selected purchase for editing/ viewing details
    const [showDetailsModal, setShowDetailsModal] = useState(false); //show modal for viewing purchase details
    const [supplierFilter, setSupplierFilter] = useState(''); //search term for suppliers
    const [startDateFilter, setStartDateFilter] = useState(''); //search term for date of purchase
    const [endDateFilter, setEndDateFilter] = useState(''); //search term for date of purchase
    const [isEditMode, setIsEditMode] = useState(false); //flag to indicate if we are in edit mode
    // const [purchaseReturnModal, setShowPurchaseReturnModal] = useState(false); //modal for returning purchases

    //states for editing purchase details
    const [editedDate, setEditedData] = useState('');
    const [editedInvoiceNumber, setEditedInvoiceNumber] = useState('');
    const [editedSupplier, setEditedSupplier] = useState('');
    const [isReturnModalOpen, setIsReturnModalOpen] = useState(false); //flag to indicate if return modal is open

    // state for holding audit log data
    const [selectedPurchaseAuditLog, setSelectedPurchaseAuditLog] = useState([]); //selected purchase for viewing audit log

    // states for updating accounts and transactions
    const { loadTransactions } = useTransactions();
    const { fetchAccountsData } = useAccounts();

    const navigate = useNavigate();

    const purchaseModalRef = useRef(); //reference to the modal for adding purchases
    const showDetailsModalRef = useRef(); //reference to the modal for viewing purchase details


    // fetch purchases data on component mount
    useEffect(() => {
        // fetchAllPurchases();
        fetchAllSuppliers();
        fetchAllProductsForPurchase();
    }, [fetchAllSuppliers, fetchAllProductsForPurchase]);

    useEffect(() => {
        fetchCurrentStore()
            .then(setCurrentStore)
            .catch((error) => console.error("Unable to load active store for purchases", error));
    }, []);

    useEffect(() => {
        // build a filter object
        const filters = {};
        if (supplierFilter) filters.searchTerm = supplierFilter;
        if (startDateFilter) filters.start_date = startDateFilter;
        if (endDateFilter) filters.end_date = endDateFilter;

        fetchPurchasesPaginated(currentPage, filters);
    }, [currentPage, supplierFilter, startDateFilter, endDateFilter, fetchPurchasesPaginated]);

    const totalPages = Math.ceil(totalPurchases / entriesPerPage);
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleBack = () => {
        navigate(-1);
    }

    const handleClickOutside = (e, modalRef, closeModal) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            closeModal();
        }
    };

    // useEffect hook to handle click outside event
    useEffect(() => {
        const onOutsideClick = (e) => {
            handleClickOutside(e, purchaseModalRef, () => setShowPurchaseModal(false));
            handleClickOutside(e, showDetailsModalRef, () => setShowDetailsModal(false));
            // handleClickOutside(e, purchaseReturnModalRef, () => setShowPurchaseReturnModal(false));
        };

        document.addEventListener('mousedown', onOutsideClick);
        return () => {
            document.removeEventListener('mousedown', onOutsideClick);
        };
    }, []);

    // added with duplicate check
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (currentStore?.store_type !== "WAREHOUSE") {
            alert("Purchases can only be created in the Central Warehouse.")
            return;
        }

        try {
            await createPurchase(newPurchase);
            setNewPurchase(initialNewPurchaseState);
            setTotalAmount(0);
            setShowPurchaseModal(false);
            await loadTransactions();
            await fetchAccountsData();
        } catch (error) {
            if (error.response && error.response.data) {
                if (Array.isArray(error.response.data.invoice_number)) {
                    // DRF always returns a 400 error with field -> array of messages thus [0], which is taken from the
                    // console error message in purchasecontext.js; "invoice_number":
                    // ["purchase with this invoice number already exists."]
                    alert(error.response.data.invoice_number[0]);
                    return;
                }
            }
            console.error("An error occurred while creating the purchase:", error);
        }
    };

    // additional functions for handling purchases would go here
    const handlePurchaseShowModal = () => {
        if (currentStore?.store_type !== "WAREHOUSE") {
            alert("Purchases are centralized in the Central Warehouse only. Please switch to the Central Warehouse.")
            return;
        }
        // setNewPurchase(initialNewPurchaseState); //reset new purchase state
        // setTotalAmount(0); //reset total amount
        setShowPurchaseModal(true); //open modal
    }
    const handlePurchaseHideModal = () => setShowPurchaseModal(false);

    //function to handle adding a new purchase line
    const handleAddPurchaseLine = () => {
        setNewPurchase({
            ...newPurchase,
            products: [...newPurchase.products, {productId: '', unitId: '', quantity: 0, purchase_price: '',
                conversion_factor: 1.0, last_purchase_price_base: null}]
        });
    };

    const getSuggestedPurchasePrice = (lastPurchasePriceBase, conversionFactor = 1) => {
        const basePrice = parseFloat(lastPurchasePriceBase);
        const normalizedConversionFactor = parseFloat(conversionFactor) || 1.0;

        if (Number.isNaN(basePrice)) {
            return '';
        }

        return (basePrice * normalizedConversionFactor).toFixed(5);
    };

    const productFilterOption = (option, inputValue) => {
        const label = (option.label || '').toLowerCase();
        const searchWords = inputValue.toLowerCase().trim().split(/\s+/).filter(Boolean);
        if (!searchWords.length) return true;
        return searchWords.every((word) => label.split(/\s+/).some((part) => part.startsWith(word)) || label.includes(word));
    };

    // function to update new purchase details
    const handleFieldChange = (e, index) => {
        const {name, value} = e.target;
        const list = [...newPurchase.products];
        // list[index][name] = parseFloat(value) || 0;

        list[index][name] = value;

        if (name === 'unitId') {
            const selectedUnit = list[index].availableUnits.find((u) => u.id === parseInt(value));

            if (selectedUnit) {
                list[index]['conversion_factor'] = selectedUnit.conversion_factor || 1.0;
                list[index].purchase_price = getSuggestedPurchasePrice(
                    list[index].last_purchase_price_base,
                    list[index].conversion_factor
                );
            } else {
                list[index]['conversion_factor'] = 1.0;
                list[index].purchase_price = '';
            }
        }

        setNewPurchase({...newPurchase, products: list});
        calculateTotal(list);
    };

    const handleProductChange = (selectedOption, index) => {
        const list = [...newPurchase.products];
        list[index].productId = selectedOption.value;

        // fetch units for the selected product
        const product = productsForPurchase.find((p) => p.value === selectedOption.value);

        const availableUnits = [];

        // base unit first (conversion = 1)
        if (product?.base_unit) {
            availableUnits.push({
                id: product.base_unit.id,
                name: product.base_unit.name,
                conversion_factor: 1,
                is_base: true,
            });
        }

        // alternative units
        if (product?.units?.length) {
            product.units.forEach((u) => {
                availableUnits.push({
                    id: u.unit.id,
                    name: u.unit.name,
                    conversion_factor: u.conversion_factor,
                    is_base: false,
                });
            });
        }

        list[index].availableUnits = availableUnits;
        list[index].last_purchase_price_base = product?.last_purchase_price_base ?? null;

        // if only base unit exists, auto-select it and suggest the last base purchase price
        if (availableUnits.length <= 1) {
            const defaultUnit = availableUnits[0];
            list[index].unitId = defaultUnit ? defaultUnit.id : '';
            list[index].conversion_factor = defaultUnit ? defaultUnit.conversion_factor : 1;
            list[index].purchase_price = getSuggestedPurchasePrice(
                list[index].last_purchase_price_base,
                list[index].conversion_factor
            );
        } else {
            list[index].unitId = '';
            list[index].conversion_factor = 1; //reset conversion factor to default
            list[index].purchase_price = '';
        }

        setNewPurchase({...newPurchase, products: list});
        calculateTotal(list);
    }

    //function to update new purchase details (non-product fields)
    const handlePurchaseDetailsChange = (e) => {
        const {name, value} = e.target;
        setNewPurchase({...newPurchase, [name]: value});
    }

    const calculateTotal = (productList) => {
        if (!productList || productList.length === 0) {
            setTotalAmount(0);
            return;
        }

        const total = productList.reduce((acc, product) => {
            const quantity = parseFloat(product.quantity) || 0;
            const purchasePrice = parseFloat(product.purchase_price) || 0;
            return acc + (quantity * purchasePrice);
        }, 0);
        setTotalAmount(total);
    };

    const handleDeletePurchaseLine = (index) => {
        // I will return to check on why the below typescipt error still persists
        setNewPurchase((prevNewPurchase) => {
            const newProducts = prevNewPurchase.products.filter((product, i) => i !== index);
            calculateTotal(newProducts); // pass updated product list to calculate total
            return {...prevNewPurchase, products: newProducts};
        });
        calculateTotal();
    };

    // const handleDeletePurchase = async (purchaseId) => {
    //     await deletePurchase(purchaseId);
    // }

    const handleSupplierClick = async (purchases) => {
        setSelectedPurchase(purchases);
        setSelectedPurchaseAuditLog(purchases.audit_logs);
        setShowDetailsModal(true);
    }

    const saveEdits = async () => {
        if (!selectedPurchase?.id) {
            console.error("No purchase selected for update");
            return;
        }

        const updatedPurchase = {
            id: selectedPurchase.id,
            supplier: editedSupplier,
            purchase_date: editedDate,
            invoice_number: editedInvoiceNumber,
        };

        try {
            const savedPurchase = await updatePurchase(updatedPurchase);

            // Trust backend response, not local mutation
            setSelectedPurchase(savedPurchase);
            setIsEditMode(false);
        } catch (error) {
            console.error("Failed to update purchase:", error);
            alert("Failed to update purchase. Please try again.");
        }
    };

    // function to format date to YYYY-MM-DD format for input since date in purchase table is in DD-MM-YYYY format
    const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); //month is zero-indexed
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    // function to pre-populate the edit fields
    const enterEditMode = () => {
        const formattedDate = formatDateForInput(selectedPurchase.purchase_date);
        console.log('date to be edited: ', formattedDate);
        setEditedData(formattedDate);
        setEditedInvoiceNumber(selectedPurchase.invoice_number);
        setEditedSupplier(selectedPurchase.supplier);
        setIsEditMode(true);
    }

    // function to open the return modal
    const openReturnModal = (purchase) => {
        setSelectedPurchase(purchase); //set the selected purchase
        setIsReturnModalOpen(true);
    }

    const handleReturnProcessed = async () => {
        try {
            const updatedPurchase = await fetchAllPurchases(selectedPurchase.id);
            setSelectedPurchase(updatedPurchase);
            setIsReturnModalOpen(false);
        } catch (error) {
            console.error('Error fetching updated purchase after return:', error);
        }
    };

    const maxLinks = 5;
    let startLink = Math.max(currentPage - 2, 1);
    let endLink = Math.min(startLink + maxLinks - 1, totalPages);

    if (endLink > totalPages) {
      endLink = totalPages;
      startLink = Math.max(endLink - (maxLinks - 1), 1);
    }

    const pageNumbersToShow = [];
    for (let i = startLink; i <= endLink; i++) {
      pageNumbersToShow.push(i);
    }


    return(
        <div>
            <div className="back-button-container">
                <Button variant="danger" onClick={handleBack}>Back</Button>
            </div>
            <h1>Purchases</h1>
            {currentStore && currentStore.store_type !== "WAREHOUSE" && (
                <Alert variant="warning">
                    Purchases are created only in the Central Warehouse. Use a stock transfer to supply this store.
                </Alert>
            )}
            <Button
                variant="primary"
                onClick={handlePurchaseShowModal}
                disabled={!currentStore || currentStore.store_type !== "WAREHOUSE"}
            >
                Add Purchase
            </Button>
            <div className="filter-section mt-3 mb-3">
                <Row>
                    <Col md={6}>
                        <FormControl
                            placeholder="Search purchase by supplier name"
                            onChange={(e) => setSupplierFilter(e.target.value)}
                        />
                    </Col>
                    <Col md={3}>
                        <FormControl
                            type="date"
                            placeholder="Start date"
                            onChange={(e)=>setStartDateFilter(e.target.value)}
                        />
                    </Col>
                    <Col md={3}>
                        <FormControl
                            type="date"
                            placeholder="End date"
                            onChange={(e)=>setEndDateFilter(e.target.value)}
                        />
                    </Col>
                </Row>
            </div>
            <Table striped bordered hover responsive>
                <thead>
                    <tr>
                        {/*<th>Status</th>*/}
                        <th>Supplier</th>
                        <th>Invoice no</th>
                        <th>Total Amount</th>
                        <th>Purchase Date</th>
                        <th>Returns</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {/*{filteredPurchases.map(purchase => (*/}
                    {purchases.map(purchase => (
                        <tr key={purchase.id}>
                            <td>
                                <Button variant="link" onClick={() => handleSupplierClick(purchase)}>
                                    {purchase.supplier_name}
                                </Button>
                            </td>
                            <td>{purchase.invoice_number}</td>
                            <td>{parseFloat(purchase.total_amount).toFixed(2)}</td>
                            <td>{new Date(purchase.purchase_date).toLocaleDateString('en-GB')}</td>
                            {/*<td>{purchase.has_return && <span className="return-flag">Returned</span>}</td>*/}
                            <td>
                                {purchase.items?.some(
                                    item => parseFloat(item.returned_quantity || 0) > 0
                                ) && (<span className="return-flag">Returned</span>
                                )}
                            </td>
                            {/*en-GB formats the date in the British English locale*/}
                            <td className="d-flex justify-content-between">
                                <Button variant="info" onClick={() => handleSupplierClick(purchase)} className="mr-1">
                                    <FontAwesomeIcon icon={faEye} />
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            <div className="mt-4 d-flex justify-content-center">
                <Pagination>
                    <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1}/>
                    <Pagination.Prev onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
                                     disabled={currentPage === 1}/>
                    {/*numeric links*/}
                    {pageNumbersToShow.map((page) => (
                        <Pagination.Item key={page} active={page === currentPage}
                                         onClick={() => handlePageChange(page)}>
                            {page}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages }/>
                    <Pagination.Last onClick={() => handlePageChange(totalPages)}
                                        disabled={currentPage === totalPages}/>
                </Pagination>
            </div>

            {/*form for adding/updating purchases would go here*/}
            <Modal show={showPurchaseModal} onHide={handlePurchaseHideModal} size='lg' dialogClassName="modal-xl" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add Purchase</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Supplier</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="supplier"
                                        value={newPurchase.supplier}
                                        onChange={handlePurchaseDetailsChange}
                                        required
                                    >
                                        <option value="">Select Supplier</option>
                                        {suppliers.map(supplier => (
                                            <option key={supplier.id} value={supplier.id}>{supplier.supplier_name}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Purchase Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="purchase_date"
                                        value={newPurchase.purchase_date}
                                        onChange={handlePurchaseDetailsChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Invoice Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="invoice_number"
                                        value={newPurchase.invoice_number}
                                        onChange={handlePurchaseDetailsChange}
                                        // isInvalid={!!errorMessage}
                                        required
                                    />
                                    {/*inline bootstrap feedback under the invoice number field*/}
                                    {/*<Form.Control.Feedback type="invalid">*/}
                                    {/*    {errorMessage}*/}
                                    {/*</Form.Control.Feedback>*/}
                                </Form.Group>
                            </Col>
                        </Row>
                        <br/>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th style={{ width: '40%' }}>Product</th>
                                    <th style={{ width: '15%' }}>Quantity</th>
                                    <th style={{ width: '15%' }}>Unit of Measure</th>
                                    <th>Purchase Unit Price</th>
                                    <th>Amount</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {newPurchase.products.map((product, index) => (
                                    <tr key={index}>
                                        <td>
                                            <Select
                                                value={productsForPurchase.find(p => p.value === product.productId)}
                                                options={productsForPurchase}
                                                onChange={(selectedOption) =>
                                                    handleProductChange(selectedOption, index)}
                                                isSearchable={true}
                                                filterOption={productFilterOption}
                                                placeholder="Select Product"
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                name="quantity"
                                                value={product.quantity}
                                                onChange={(e) => handleFieldChange(e, index)}
                                                required
                                            />
                                        </td>
                                        <td>
                                            {product.availableUnits && product.availableUnits.length > 1 ? (
                                                <Form.Control
                                                    as="select"
                                                    name="unitId"
                                                    value={product.unitId}
                                                    onChange={(e) => handleFieldChange(e, index)}
                                                    required
                                                >
                                                    <option value="">Select Unit</option>
                                                    {product.availableUnits.map((unit) => (
                                                        <option key={unit.id} value={unit.id}>{unit.name}</option>
                                                    ))}
                                                </Form.Control>
                                            ) : (
                                                <span>Base Unit</span> // or any indication that no unit selection is needed
                                            )}
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="number"
                                                step="0.00001"
                                                name="purchase_price"
                                                value={product.purchase_price}
                                                onChange={(e) => handleFieldChange(e, index)}
                                                required
                                            />
                                        </td>
                                        <td>{((parseFloat(product.quantity) || 0) * (parseFloat(product.purchase_price) || 0)).toFixed(2)}</td>
                                        <td>
                                            <Button variant="danger" onClick={() => handleDeletePurchaseLine(index)}>
                                                <FontAwesomeIcon icon="trash"/>
                                            </Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan={3}><strong>Total Amount</strong></td>
                                    <td colSpan={2}>{totalAmount.toFixed(2)}</td>
                                </tr>
                            </tfoot>
                        </Table>
                        <Button variant="primary" onClick={handleAddPurchaseLine}>+ Add Line</Button>
                        <br/>
                        <Button variant="success" type="submit" className="mt-3">Save Purchase</Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/*Purchase details modal*/}
            {showDetailsModal && selectedPurchase && (
                <Modal show={showDetailsModal} onHide={() => setShowDetailsModal(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Purchase Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/*{error && <Alert variant="danger">{error}</Alert>}*/}
                        {!isEditMode ? (
                            <>
                                <h5>Purchase Summary</h5>
                                <p><strong>Supplier: </strong>{selectedPurchase.supplier_name}</p>
                                <p><strong>Date:</strong> {new Date(selectedPurchase.purchase_date).toLocaleDateString('en-GB')}</p>
                                <p><strong>Invoice Number:</strong> {selectedPurchase.invoice_number}</p>
                                <p><strong>Total Amount:</strong> {parseFloat(selectedPurchase.total_amount).toFixed(2)}</p>
                                <Button variant="primary" onClick={enterEditMode} className="button-spacing">Edit</Button>
                                <Button variant="danger" onClick={() => openReturnModal(selectedPurchase)}>Return Purchase</Button>
                            </>
                        ) : (
                            <>
                                <Form.Group>
                                    <Form.Label>Supplier</Form.Label>
                                    <Form.Control
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               as="select"
                                        name="supplier"
                                        value={editedSupplier}
                                        onChange={(e) => setEditedSupplier(e.target.value)}
                                    >
                                        {suppliers.map((supplier) => (
                                            <option key={supplier.id} value={supplier.id}>{supplier.supplier_name}</option>
                                        ))}
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Purchase Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={editedDate}
                                        onChange={(e) => setEditedData(e.target.value)}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Invoice Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={editedInvoiceNumber}
                                        onChange={(e) => setEditedInvoiceNumber(e.target.value)}
                                    />
                                </Form.Group>
                                <Button variant="primary" onClick={saveEdits} className="mr=1">Save Changes</Button>
                                <Button variant="secondary" onClick={() => setIsEditMode(false)}>Cancel</Button>
                                <br/>
                            </>
                        )}
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Quantity</th>
                                    <th>Unit Price</th>
                                    <th>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                            {selectedPurchase.items.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.product_name || 'Product not found'} {item.unit_name ? `${item.unit_name}` : ''}</td>
                                    <td>{parseFloat(item.quantity).toFixed(2)}
                                        {item.returned_quantity && parseFloat(item.returned_quantity) > 0 && (
                                            <span className="text-danger ml-2">
                                                    <FaUndoAlt/> {parseFloat(item.returned_quantity).toFixed(2)}
                                                </span>
                                        )}
                                    </td>
                                    <td>{parseFloat(item.purchase_price).toFixed(2)}</td>
                                    {/*<td>{(item.quantity * item.purchase_price).toFixed(2)}</td>*/}
                                    <td>{(parseFloat(item.quantity) * parseFloat(item.purchase_price)).toFixed(2)}</td>
                                </tr>
                            ))}
                            </tbody>
                        </Table>
                        <h3>Audit Log</h3>
                        <ul>
                            {selectedPurchaseAuditLog.map((log) => (
                                <li key={log.id}>
                                    <p><strong>Action: </strong> {log.action_taken}</p>
                                    <p><strong>User: </strong> {log.username}</p>
                                    <p><strong>Date: </strong> {new Date(log.created_at).toLocaleDateString('en-GB')}</p>
                                </li>
                                ))}
                        </ul>
                    </Modal.Body>
                </Modal>
            )}

            {/*Return purchase modal*/}
            {isReturnModalOpen && selectedPurchase && (
                <Modal show={isReturnModalOpen} onHide={() => setIsReturnModalOpen(false)} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>Return Purchase</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ReturnPurchase
                            purchase={selectedPurchase}
                            onClose={() => setIsReturnModalOpen(false)}
                            onReturnProcessed={handleReturnProcessed}
                        />
                    </Modal.Body>
                </Modal>
            )}
        </div>
    );
}

export default Purchase;
